import { Center, Icon, Stack } from "@chakra-ui/react";

import { useAppModal } from "../../Modals";
import { GarbageIcon } from "../../../icons";
import { ICard } from "../../../../api/cards/types.ts";
import { CardItemDeletionModal } from "./CardItemDeletionModal.tsx";

interface Props {
  card: ICard;
  isProductStatusChanging: boolean;
}

export function CardItemDeletion({ card, isProductStatusChanging }: Props) {
  const { showModal, hideModal } = useAppModal();

  const onClick = () => {
    showModal({
      header: "Удалить способ оплаты",
      content: (onClose, block) => (
        <CardItemDeletionModal
          card={card}
          onCancel={onClose}
          hideModal={hideModal}
          blockModalClosing={block}
        />
      ),
    });
  };

  return (
    <Stack
      position="absolute"
      right="0"
      top="0"
      h="66px"
      w="58px"
      pointerEvents={isProductStatusChanging ? "none" : "auto"}
      cursor={isProductStatusChanging ? "default" : "pointer"}
      onClick={onClick}
    >
      <Center flex="1">
        <Icon as={GarbageIcon} boxSize="18px" />
      </Center>
    </Stack>
  );
}
